import Layout from '@/components/layout.vue'
const router_modular = [{
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login.vue')
    },{
        path: '/jump',
        name: 'jump',
        component: () => import('@/views/login/jump.vue')
    },
    {
        path: '/reg',
        name: 'reg',
        component: () => import('@/views/login/reg.vue')
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import('@/views/login/agreement.vue')
    },
    {
        path: '/foundpwd',
        name: 'foundpwd',
        component: () => import('@/views/login/foundpwd.vue')
    },


    {
        path: '/',
        name: 'rootPath',
        redirect: '/index'
    },
    {
        path: '/page',
        component: Layout,
        hidden: true,
        children: [{
                path: '/home',
                name: 'homePage',
                component: () => import('@/views/home/index.vue'),
                meta: {
                    keepAlive: false, // 判断是否需要缓存当前组件
                }
            },
            {
                path: '/index',
                redirect: '/home',

            },
            {
                path: '/apps',
                name: 'appsPage',
                component: () => import('@/views/apps/index.vue'),
                meta: {
                    keepAlive: true, // 判断是否需要缓存当前组件
                }
            },

            {
                path: '/news',
                name: 'newsPage',
                component: () => import('@/views/news/index.vue')
            },
            {
                path: '/my',
                name: 'my',
                component: () => import('@/views/my/index.vue')
            },
            {
                path: '/syncCourse',
                name: 'syncCourse',
                component: () => import('@/views/home/syncCourse.vue'),
                meta: {
                    keepAlive: true,
                    isUseCache: false
                }
            },
            {
                path: '/preciseLearning',
                name: 'preciseLearning',
                component: () => import('@/views/home/preciseLearning.vue'),
                meta: {
                    keepAlive: true,
                    isUseCache: false
                }
            },
            {
                path: '/map',
                name: 'mapPage',
                component: () => import('@/views/map/index.vue'),
                meta: {
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: '/mapDetail',
        name: 'mapDetailPage',
        component: () => import('@/views/map/detail.vue'),
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/mapVideo',
        name: 'mapVideoPage',
        component: () => import('@/views/map/video.vue'),
        meta: {
            keepAlive: false
        }
    },
    {
        path: '/syncCourseDetail',
        name: 'syncCourseDetail',
        component: () => import('@/views/home/syncCourseDetail.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
        }
    },
    {
        path: '/appsDetail',
        name: 'appsDetail',
        component: () => import('@/views/apps/detail.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
        }
    },
    {
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import('@/views/news/detail.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
        }
    },
    {
        path: '/feedback',
        name: 'feedbackPage',
        component: () => import('@/views/my/feedback.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/addStudent',
        name: 'addStudentPage',
        component: () => import('@/views/my/addStudent.vue'),
        meta: {
            keepAlive: false, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/notice',
        name: 'noticePage',
        component: () => import('@/views/my/notice.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/noticeDetail',
        name: 'noticeDetail',
        component: () => import('@/views/my/noticeDetail.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/message',
        name: 'messagePage',
        component: () => import('@/views/my/message.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/messageDetail',
        name: 'messageDetail',
        component: () => import('@/views/my/messageDetail.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/topic',
        name: 'topicPage',
        component: () => import('@/views/news/topic.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/task',
        name: 'task',
        component: () => import('@/views/my/task.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    }, {
        path: '/taskDetail',
        name: 'taskDetail',
        component: () => import('@/views/my/taskDetail.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/editInfo',
        name: 'editInfo',
        component: () => import('@/views/my/editInfo.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/childInfo',
        name: 'childInfo',
        component: () => import('@/views/my/childInfo.vue'),
        meta: {
            keepAlive: true, // 判断是否需要缓存当前组件
            isUseCache: false
        }
    },
    {
        path: '/editpwd',
        name: 'editpwd',
        component: () => import('@/views/my/editpwd.vue')
    },
    {
        path: '/home/editpwd',
        name: 'homeEditPwd',
        component: () => import('@/views/home/editPwd.vue')
    },
    {
        path: '/appDownload',
        name: 'appDownload',
        component: () => import('@/views/download/app.vue')
    },
    {
        path: '/guide',
        name: 'guide',
        component: () => import('@/views/home/guide.vue')
    },
    {
        path: '/learningResources',
        name: 'learningResources',
        component: () => import('@/views/home/learningResources.vue'),
        meta: {
            keepAlive: true,
            isUseCache: false
        }
    },
    {
        path: '/learningResourceDetail',
        name: 'learningResourceDetail',
        component: () => import('@/views/home/learningResourceDetail.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/wrongQuestion',
        name: 'wrongQuestion',
        component: () => import('@/views/home/wrongQuestion.vue'),
        meta: {
            keepAlive: true,
            isUseCache: false
        }
    },
    {
        path: '/evaluationReport',
        name: 'evaluationReport',
        component: () => import('@/views/home/evaluationReport.vue'),
        meta: {
            keepAlive: true,
            isUseCache: false
        }
    },
    {
        path: '/myClass',
        name: 'myClass',
        component: () => import('@/views/my/myClass.vue')
    },
    {
        path: '/agreementView',
        name: 'agreementView',
        component: () => import('@/views/agreement/index.vue')
    },
    {
        path: '/resources',
        name: 'resources',
        component: () => import('@/views/my/resources.vue')
    },
    {
        path: '/resourceDetail',
        name: 'resourceDetail',
        component: () => import('@/views/my/resourceDetail.vue')
    },
    {
        path: '/videoPlay',
        name: 'videoPlay',
        component: () => import('@/views/other/videoPlay.vue')
    },
    {
        path: '/miniapp-redirect',
        name: 'miniapp-redirect',
        component: () => import('@/views/other/miniapp-redirect.vue')
    },
    {
        path: '/scheme-redirect',
        name: 'scheme-redirect',
        component: () => import('@/views/other/scheme-redirect.vue')
    },
    {
        path: '/activityCenter',
        name: 'activityCenter',
        component: () => import('@/views/activity/activityCenter.vue'),
        meta: {
            keepAlive: true,
            isUseCache: false
        }
    },
    {
        path: '/activity/help',
        name: 'activityHelp',
        component: () => import('@/views/activity/activityHelp.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/activity/wechat-qr',
        name: 'wechatQr',
        component: () => import('@/views/activity/wechatQr.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/activity/official-account',
        name: 'officialAccount',
        component: () => import('@/views/activity/officialAccount.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/research/researchList',
        name: 'researchListPage',
        component: () => import('@/views/research/researchList.vue'),
        meta: {
            keepAlive: true,
            isUseCache: false
        }
    },
    {
        path: '/research/detail',
        name: 'researchDetailPage',
        component: () => import('@/views/research/researchDetail.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/freeActivity',
        name: 'freeActivityPage',
        component: () => import('@/views/activity/freeActivity.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/pointsMall',
        name: 'pointsMall',
        component: () => import('@/views/my/pointsMall.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/productDetail',
        name: 'productDetail',
        component: () => import('@/views/my/productDetail.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    },
    {
        path: '/pointsRecords',
        name: 'pointsRecords',
        component: () => import('@/views/my/pointsRecords.vue'),
        meta: {
            keepAlive: false,
            isUseCache: false
        }
    }
]
export default router_modular
